<div class="session-info">
  <h4 translate>session.learner</h4>
  <div class="session-info__item">
    <p translate>learner.name</p>
    <p>{{ learner?.name }}</p>
  </div>

  @if (learner?.email) {
    <div class="session-info__item">
      <p translate>learner.email</p>
      <p>{{ learner?.email }}</p>
    </div>
  }

  @if (session.idVerified) {
    <div class="session-info__photos">
      <div class="session-info__item">
        <p translate>session-details.component.face-photo</p>
        <img [src]="identification.facePhoto.url" />
      </div>
      <div class="session-info__item">
        <p translate>session-details.component.photo-id</p>
        <img [src]="identification.idPhoto.url" />
      </div>
    </div>
  }
</div>

<div class="session-info">
  <h4 translate>session.details</h4>
  <div class="session-info__item">
    <p translate>session.website</p>
    <p>{{ session.domain }}</p>
  </div>
  <div class="session-info__item">
    <p translate>session.name</p>
    <p>{{ session.name }}</p>
  </div>
  <div class="session-info__item">
    <p translate>session.created-at</p>
    <p>{{ session.createdAt | date: 'medium' }}</p>
  </div>

  @if (session.finishedAt) {
    <div class="session-info__item">
      <p translate>session.finished-at</p>
      <p>{{ session.finishedAt | date: 'medium' }}</p>
    </div>
  }

  @if (tokboxEnabled) {
    <div class="session-info__item session-info__item--agent">
      <div class="field is-grouped">
        <p class="control" translate>session.live-agent</p>
        <span class="icon control" [ngClass]="{ 'is-success': tokbox.connected }">
          <i lvIcon="user"></i>
        </span>
      </div>

      <lv-tokbox-view [tokbox]="tokbox" [autoConnect]="true"></lv-tokbox-view>
    </div>
  }
</div>

<div class="session-actions">
  <h4>{{ translatedVerifyLabel }}</h4>
  <button class="button is-success is-medium" (click)="pass()" [disabled]="!passEnabled()" translate>app.pass</button>
  @if (!session.idVerified) {
    <button class="button is-warning is-medium" (click)="onRetake()" [disabled]="!passEnabled()" translate>
      app.retake-document
    </button>
  }
  <button class="button is-failure is-medium" (click)="fail()" [disabled]="failDisabled()" translate>app.fail</button>
</div>
